module.exports = __webpack_public_path__ + "img/instagram.8a72973b.svg";